let controller1 = new ScrollMagic.Controller();

let scene3 = new ScrollMagic.Scene({
    offset: -50,
    triggerElement: '.box3',
    triggerHook: "0",
    duration:600,
})
scene3.setPin('.box3');
scene3.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    if(index<81){
        $('.box3_mask').css({background:`rgba(0,0,0,${mapValue(index,0,80,0,0.6)})`})
        $('.box3_text').removeClass('showup1')
    }else{
        $('.box3_mask').css({background:`rgba(0,0,0,0.6)`})
        $('.box3_text').addClass('showup1')
    }
})


let scene2 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box2',
    triggerHook: "onenter",
    duration:0,
})
scene2.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box2_items').addClass('showup')
    if(index<2){
        $('.box2_items').removeClass('showup')
    }
})

let scene2_1 = new ScrollMagic.Scene({
    offset: -150,
    triggerElement: '.box2',
    triggerHook: "onenter",
    duration:0,
})
scene2_1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box2_title').addClass('showup')
    if(index<2){
        $('.box2_title').removeClass('showup')
    }
})

let scene5 = new ScrollMagic.Scene({
    offset: 50,
    triggerElement: '.box5',
    triggerHook: "onenter",
    duration:0,
})
scene5.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box5_text').addClass('showup')
    if(index<2){
        $('.box5_text').removeClass('showup')
    }
})


let scene6 = new ScrollMagic.Scene({
    offset: 200,
    triggerElement: '.box6',
    triggerHook: "onenter",
    duration:0,
})
scene6.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box6_content').addClass('showup')
    if(index<2){
        $('.box6_content').removeClass('showup')
    }
})

let scene7 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box7',
    triggerHook: "onenter",
    duration:0,
})
scene7.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box7_title').addClass('showup')
    if(index<2){
        $('.box7_title').removeClass('showup')
    }
})

let scene8 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box8',
    triggerHook: "onenter",
    duration:0,
})
scene8.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box8_title').addClass('showup')
    if(index<2){
        $('.box8_title').removeClass('showup')
    }
})

let scene9 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box9',
    triggerHook: "onenter",
    duration:0,
})
scene9.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box9_title').addClass('showup')
    if(index<2){
        $('.box9_title').removeClass('showup')
    }
})

let scene10 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box10',
    triggerHook: "onenter",
    duration:0,
})
scene10.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box10_title').addClass('showup')
    if(index<2){
        $('.box10_title').removeClass('showup')
    }
})

let scene11 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box11',
    triggerHook: "onenter",
    duration:0,
})
scene11.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box11_title').addClass('showup1')
    if(index<2){
        $('.box11_title').removeClass('showup1')
    }
})



controller1.addScene([scene2,scene2_1,scene3,scene5,scene6,scene7,scene8,scene9,scene10,scene11]); 

//box4
var SwiperFlag = 1

$('.box32_icon').click(function(){
    var index = $(this).parent().index()+1
    SwiperFlag = index;
    box32Swiper(index)
    // clearInterval(inter);
    // inter = setInterval(() => {
    //     if(SwiperFlag<8){
    //         SwiperFlag++;
    //     }else{
    //         SwiperFlag = 1
    //     }
    //     box32Swiper(SwiperFlag)
    // }, 4000);
})

// var inter = setInterval(() => {
//     if(SwiperFlag<8){
//         SwiperFlag++;
//     }else{
//         SwiperFlag = 1
//     }
//     box32Swiper(SwiperFlag)
// }, 3000);

function box32Swiper(index){
     //img
     $('.bt32_img').hide()
     $(`.bt32_img${index}`).show()
     $('.br32_img').hide()
     $(`.br32_img${index}`).show()
     //title
     $('.colorName').hide()
     $(`.colorName${index}`).show()
     //icon
     $('.box32_icon').show()
     $('.box32_iconActive').hide()
     $(`.box32_cItems .box32_icons:nth-child(${index}) .box32_icon`).hide()
     $(`.box32_cItems .box32_icons:nth-child(${index}) .box32_iconActive`).show()
}

let isDragging = false;
let startPositionX = 0;
let endPositionX = 0;

const dragElement = document.getElementById('dragElement');

dragElement.addEventListener('touchstart', (event) => {
  isDragging = true;
  startPositionX = event.touches[0].clientX;
});

dragElement.addEventListener('touchmove', (event) => {
  if (isDragging) {
    endPositionX = event.touches[0].clientX;
    event.preventDefault(); // 防止滚动
  }
});

dragElement.addEventListener('touchend', () => {
  if (isDragging) {
    isDragging = false;
    const deltaX = endPositionX - startPositionX;

    if (deltaX > 0) {
        if(SwiperFlag>1){
            SwiperFlag--;
            box32Swiper(SwiperFlag)
          }
      
    } else if (deltaX < 0) {
        if(SwiperFlag<16){
            SwiperFlag++;
            box32Swiper(SwiperFlag)
        }
    }
  }
});

//box10
setInterval(() => {
    $('.box10_img img').hide()
    $('.box10_img img:nth-child(1)').show()
    setTimeout(() => {
        $('.box10_img img').hide()
        $('.box10_img img:nth-child(2)').show()
    }, 1000);
    setTimeout(() => {
        $('.box10_img img').hide()
        $('.box10_img img:nth-child(3)').show()
    }, 2000);
}, 3000);


$('.pnr_buy').click(function(){ 
    window.open('https://store.oxva.com/products/oxva-xlim-go-kit'); 
})

$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})